import { useExpensableGroupsDataTable } from 'generated/resources/datatable.graphql'
import { ExpensePageFinanceCustomCategoryFragment } from 'generated/resources/graphql'

import ownerFilter from 'modules/expenses/components/expenses/DataTable/_Filters/OwnerFilter'
import { Currency } from 'modules/expenses/hooks/useExpensesListPage'
import { type Section } from 'modules/expenses/lib/RouteContextParams'
import { isMyExpensesSection } from 'modules/expenses/lib/common'

import categoryFilter from './CategoryFilter'
import currencyFilter from './CurrencyFilter'
import legalEntityFilter from './LegalEntityFilter'
import pendingApprovalFilter from './PendingApprovalFilter'
import reportDateFilter from './ReportDateFilter'
import reportedByFilter from './ReportedByFilter'
import statusFilter from './StatusFilter'
import subcategoryFilter from './SubcategoryFilter'
import { InitialFilterValue } from './types'

interface Props {
  categories: ExpensePageFinanceCustomCategoryFragment[]
  currencies: Currency[]
  source: ReturnType<typeof useExpensableGroupsDataTable>
  subcategories: ExpensePageFinanceCustomCategoryFragment[]
  expensesContext: Section
  initialFilterValues: InitialFilterValue
  clearQuickFilters?: () => void
  includeReportedByFilter: boolean
}

export const allFilters = ({
  source,
  categories,
  currencies,
  subcategories,
  expensesContext,
  initialFilterValues,
  clearQuickFilters,
  includeReportedByFilter,
}: Props) => {
  const baseProps = { source, expensesContext, initialFilterValues }

  const filters = [
    statusFilter({ ...baseProps, clearQuickFilters }),
    reportDateFilter({ ...baseProps }),
    categoryFilter({ ...baseProps, categories }),
    currencyFilter({ ...baseProps, currencies }),
    subcategoryFilter({ ...baseProps, subcategories }),
  ]

  if (isMyExpensesSection(expensesContext)) {
    if (includeReportedByFilter) filters.push(reportedByFilter(baseProps))
  } else {
    filters.push(ownerFilter({ ...baseProps }))
    filters.push(legalEntityFilter({ ...baseProps }))
    filters.push(pendingApprovalFilter(baseProps))
  }

  return filters
}
